/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://static.nrk.no/dh/module/partibarometer/static/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 20);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** Virtual DOM Node */
function VNode() {}

/** Global options
 *	@public
 *	@namespace options {Object}
 */
var options = {

	/** If `true`, `prop` changes trigger synchronous component updates.
  *	@name syncComponentUpdates
  *	@type Boolean
  *	@default true
  */
	//syncComponentUpdates: true,

	/** Processes all created VNodes.
  *	@param {VNode} vnode	A newly-created VNode to normalize/process
  */
	//vnode(vnode) { }

	/** Hook invoked after a component is mounted. */
	// afterMount(component) { }

	/** Hook invoked after the DOM is updated with a component's latest render. */
	// afterUpdate(component) { }

	/** Hook invoked immediately before a component is unmounted. */
	// beforeUnmount(component) { }
};

var stack = [];

var EMPTY_CHILDREN = [];

/**
 * JSX/hyperscript reviver.
 * @see http://jasonformat.com/wtf-is-jsx
 * Benchmarks: https://esbench.com/bench/57ee8f8e330ab09900a1a1a0
 *
 * Note: this is exported as both `h()` and `createElement()` for compatibility reasons.
 *
 * Creates a VNode (virtual DOM element). A tree of VNodes can be used as a lightweight representation
 * of the structure of a DOM tree. This structure can be realized by recursively comparing it against
 * the current _actual_ DOM structure, and applying only the differences.
 *
 * `h()`/`createElement()` accepts an element name, a list of attributes/props,
 * and optionally children to append to the element.
 *
 * @example The following DOM tree
 *
 * `<div id="foo" name="bar">Hello!</div>`
 *
 * can be constructed using this function as:
 *
 * `h('div', { id: 'foo', name : 'bar' }, 'Hello!');`
 *
 * @param {string} nodeName	An element name. Ex: `div`, `a`, `span`, etc.
 * @param {Object} attributes	Any attributes/props to set on the created element.
 * @param rest			Additional arguments are taken to be children to append. Can be infinitely nested Arrays.
 *
 * @public
 */
function h(nodeName, attributes) {
	var children = EMPTY_CHILDREN,
	    lastSimple,
	    child,
	    simple,
	    i;
	for (i = arguments.length; i-- > 2;) {
		stack.push(arguments[i]);
	}
	if (attributes && attributes.children != null) {
		if (!stack.length) stack.push(attributes.children);
		delete attributes.children;
	}
	while (stack.length) {
		if ((child = stack.pop()) && child.pop !== undefined) {
			for (i = child.length; i--;) {
				stack.push(child[i]);
			}
		} else {
			if (typeof child === 'boolean') child = null;

			if (simple = typeof nodeName !== 'function') {
				if (child == null) child = '';else if (typeof child === 'number') child = String(child);else if (typeof child !== 'string') simple = false;
			}

			if (simple && lastSimple) {
				children[children.length - 1] += child;
			} else if (children === EMPTY_CHILDREN) {
				children = [child];
			} else {
				children.push(child);
			}

			lastSimple = simple;
		}
	}

	var p = new VNode();
	p.nodeName = nodeName;
	p.children = children;
	p.attributes = attributes == null ? undefined : attributes;
	p.key = attributes == null ? undefined : attributes.key;

	// if a "vnode hook" is defined, pass every created VNode to it
	if (options.vnode !== undefined) options.vnode(p);

	return p;
}

/**
 *  Copy all properties from `props` onto `obj`.
 *  @param {Object} obj		Object onto which properties should be copied.
 *  @param {Object} props	Object from which to copy properties.
 *  @returns obj
 *  @private
 */
function extend(obj, props) {
	for (var i in props) {
		obj[i] = props[i];
	}return obj;
}

/**
 * Call a function asynchronously, as soon as possible. Makes
 * use of HTML Promise to schedule the callback if available,
 * otherwise falling back to `setTimeout` (mainly for IE<11).
 *
 * @param {Function} callback
 */
var defer = typeof Promise == 'function' ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;

/**
 * Clones the given VNode, optionally adding attributes/props and replacing its children.
 * @param {VNode} vnode		The virutal DOM element to clone
 * @param {Object} props	Attributes/props to add when cloning
 * @param {VNode} rest		Any additional arguments will be used as replacement children.
 */
function cloneElement(vnode, props) {
	return h(vnode.nodeName, extend(extend({}, vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
}

// DOM properties that should NOT have "px" added when numeric
var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;

/** Managed queue of dirty components to be re-rendered */

var items = [];

function enqueueRender(component) {
	if (!component._dirty && (component._dirty = true) && items.push(component) == 1) {
		(options.debounceRendering || defer)(rerender);
	}
}

function rerender() {
	var p,
	    list = items;
	items = [];
	while (p = list.pop()) {
		if (p._dirty) renderComponent(p);
	}
}

/**
 * Check if two nodes are equivalent.
 *
 * @param {Node} node			DOM Node to compare
 * @param {VNode} vnode			Virtual DOM node to compare
 * @param {boolean} [hyrdating=false]	If true, ignores component constructors when comparing.
 * @private
 */
function isSameNodeType(node, vnode, hydrating) {
	if (typeof vnode === 'string' || typeof vnode === 'number') {
		return node.splitText !== undefined;
	}
	if (typeof vnode.nodeName === 'string') {
		return !node._componentConstructor && isNamedNode(node, vnode.nodeName);
	}
	return hydrating || node._componentConstructor === vnode.nodeName;
}

/**
 * Check if an Element has a given nodeName, case-insensitively.
 *
 * @param {Element} node	A DOM Element to inspect the name of.
 * @param {String} nodeName	Unnormalized name to compare against.
 */
function isNamedNode(node, nodeName) {
	return node.normalizedNodeName === nodeName || node.nodeName.toLowerCase() === nodeName.toLowerCase();
}

/**
 * Reconstruct Component-style `props` from a VNode.
 * Ensures default/fallback values from `defaultProps`:
 * Own-properties of `defaultProps` not present in `vnode.attributes` are added.
 *
 * @param {VNode} vnode
 * @returns {Object} props
 */
function getNodeProps(vnode) {
	var props = extend({}, vnode.attributes);
	props.children = vnode.children;

	var defaultProps = vnode.nodeName.defaultProps;
	if (defaultProps !== undefined) {
		for (var i in defaultProps) {
			if (props[i] === undefined) {
				props[i] = defaultProps[i];
			}
		}
	}

	return props;
}

/** Create an element with the given nodeName.
 *	@param {String} nodeName
 *	@param {Boolean} [isSvg=false]	If `true`, creates an element within the SVG namespace.
 *	@returns {Element} node
 */
function createNode(nodeName, isSvg) {
	var node = isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName);
	node.normalizedNodeName = nodeName;
	return node;
}

/** Remove a child node from its parent if attached.
 *	@param {Element} node		The node to remove
 */
function removeNode(node) {
	var parentNode = node.parentNode;
	if (parentNode) parentNode.removeChild(node);
}

/** Set a named attribute on the given Node, with special behavior for some names and event handlers.
 *	If `value` is `null`, the attribute/handler will be removed.
 *	@param {Element} node	An element to mutate
 *	@param {string} name	The name/key to set, such as an event or attribute name
 *	@param {any} old	The last value that was set for this name/node pair
 *	@param {any} value	An attribute value, such as a function to be used as an event handler
 *	@param {Boolean} isSvg	Are we currently diffing inside an svg?
 *	@private
 */
function setAccessor(node, name, old, value, isSvg) {
	if (name === 'className') name = 'class';

	if (name === 'key') {
		// ignore
	} else if (name === 'ref') {
		if (old) old(null);
		if (value) value(node);
	} else if (name === 'class' && !isSvg) {
		node.className = value || '';
	} else if (name === 'style') {
		if (!value || typeof value === 'string' || typeof old === 'string') {
			node.style.cssText = value || '';
		}
		if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
			if (typeof old !== 'string') {
				for (var i in old) {
					if (!(i in value)) node.style[i] = '';
				}
			}
			for (var i in value) {
				node.style[i] = typeof value[i] === 'number' && IS_NON_DIMENSIONAL.test(i) === false ? value[i] + 'px' : value[i];
			}
		}
	} else if (name === 'dangerouslySetInnerHTML') {
		if (value) node.innerHTML = value.__html || '';
	} else if (name[0] == 'o' && name[1] == 'n') {
		var useCapture = name !== (name = name.replace(/Capture$/, ''));
		name = name.toLowerCase().substring(2);
		if (value) {
			if (!old) node.addEventListener(name, eventProxy, useCapture);
		} else {
			node.removeEventListener(name, eventProxy, useCapture);
		}
		(node._listeners || (node._listeners = {}))[name] = value;
	} else if (name !== 'list' && name !== 'type' && !isSvg && name in node) {
		setProperty(node, name, value == null ? '' : value);
		if (value == null || value === false) node.removeAttribute(name);
	} else {
		var ns = isSvg && name !== (name = name.replace(/^xlink\:?/, ''));
		if (value == null || value === false) {
			if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase());else node.removeAttribute(name);
		} else if (typeof value !== 'function') {
			if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase(), value);else node.setAttribute(name, value);
		}
	}
}

/** Attempt to set a DOM property to the given value.
 *	IE & FF throw for certain property-value combinations.
 */
function setProperty(node, name, value) {
	try {
		node[name] = value;
	} catch (e) {}
}

/** Proxy an event to hooked event handlers
 *	@private
 */
function eventProxy(e) {
	return this._listeners[e.type](options.event && options.event(e) || e);
}

/** Queue of components that have been mounted and are awaiting componentDidMount */
var mounts = [];

/** Diff recursion count, used to track the end of the diff cycle. */
var diffLevel = 0;

/** Global flag indicating if the diff is currently within an SVG */
var isSvgMode = false;

/** Global flag indicating if the diff is performing hydration */
var hydrating = false;

/** Invoke queued componentDidMount lifecycle methods */
function flushMounts() {
	var c;
	while (c = mounts.pop()) {
		if (options.afterMount) options.afterMount(c);
		if (c.componentDidMount) c.componentDidMount();
	}
}

/** Apply differences in a given vnode (and it's deep children) to a real DOM Node.
 *	@param {Element} [dom=null]		A DOM node to mutate into the shape of the `vnode`
 *	@param {VNode} vnode			A VNode (with descendants forming a tree) representing the desired DOM structure
 *	@returns {Element} dom			The created/mutated element
 *	@private
 */
function diff(dom, vnode, context, mountAll, parent, componentRoot) {
	// diffLevel having been 0 here indicates initial entry into the diff (not a subdiff)
	if (!diffLevel++) {
		// when first starting the diff, check if we're diffing an SVG or within an SVG
		isSvgMode = parent != null && parent.ownerSVGElement !== undefined;

		// hydration is indicated by the existing element to be diffed not having a prop cache
		hydrating = dom != null && !('__preactattr_' in dom);
	}

	var ret = idiff(dom, vnode, context, mountAll, componentRoot);

	// append the element if its a new parent
	if (parent && ret.parentNode !== parent) parent.appendChild(ret);

	// diffLevel being reduced to 0 means we're exiting the diff
	if (! --diffLevel) {
		hydrating = false;
		// invoke queued componentDidMount lifecycle methods
		if (!componentRoot) flushMounts();
	}

	return ret;
}

/** Internals of `diff()`, separated to allow bypassing diffLevel / mount flushing. */
function idiff(dom, vnode, context, mountAll, componentRoot) {
	var out = dom,
	    prevSvgMode = isSvgMode;

	// empty values (null, undefined, booleans) render as empty Text nodes
	if (vnode == null || typeof vnode === 'boolean') vnode = '';

	// Fast case: Strings & Numbers create/update Text nodes.
	if (typeof vnode === 'string' || typeof vnode === 'number') {

		// update if it's already a Text node:
		if (dom && dom.splitText !== undefined && dom.parentNode && (!dom._component || componentRoot)) {
			/* istanbul ignore if */ /* Browser quirk that can't be covered: https://github.com/developit/preact/commit/fd4f21f5c45dfd75151bd27b4c217d8003aa5eb9 */
			if (dom.nodeValue != vnode) {
				dom.nodeValue = vnode;
			}
		} else {
			// it wasn't a Text node: replace it with one and recycle the old Element
			out = document.createTextNode(vnode);
			if (dom) {
				if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
				recollectNodeTree(dom, true);
			}
		}

		out['__preactattr_'] = true;

		return out;
	}

	// If the VNode represents a Component, perform a component diff:
	var vnodeName = vnode.nodeName;
	if (typeof vnodeName === 'function') {
		return buildComponentFromVNode(dom, vnode, context, mountAll);
	}

	// Tracks entering and exiting SVG namespace when descending through the tree.
	isSvgMode = vnodeName === 'svg' ? true : vnodeName === 'foreignObject' ? false : isSvgMode;

	// If there's no existing element or it's the wrong type, create a new one:
	vnodeName = String(vnodeName);
	if (!dom || !isNamedNode(dom, vnodeName)) {
		out = createNode(vnodeName, isSvgMode);

		if (dom) {
			// move children into the replacement node
			while (dom.firstChild) {
				out.appendChild(dom.firstChild);
			} // if the previous Element was mounted into the DOM, replace it inline
			if (dom.parentNode) dom.parentNode.replaceChild(out, dom);

			// recycle the old element (skips non-Element node types)
			recollectNodeTree(dom, true);
		}
	}

	var fc = out.firstChild,
	    props = out['__preactattr_'],
	    vchildren = vnode.children;

	if (props == null) {
		props = out['__preactattr_'] = {};
		for (var a = out.attributes, i = a.length; i--;) {
			props[a[i].name] = a[i].value;
		}
	}

	// Optimization: fast-path for elements containing a single TextNode:
	if (!hydrating && vchildren && vchildren.length === 1 && typeof vchildren[0] === 'string' && fc != null && fc.splitText !== undefined && fc.nextSibling == null) {
		if (fc.nodeValue != vchildren[0]) {
			fc.nodeValue = vchildren[0];
		}
	}
	// otherwise, if there are existing or new children, diff them:
	else if (vchildren && vchildren.length || fc != null) {
			innerDiffNode(out, vchildren, context, mountAll, hydrating || props.dangerouslySetInnerHTML != null);
		}

	// Apply attributes/props from VNode to the DOM Element:
	diffAttributes(out, vnode.attributes, props);

	// restore previous SVG mode: (in case we're exiting an SVG namespace)
	isSvgMode = prevSvgMode;

	return out;
}

/** Apply child and attribute changes between a VNode and a DOM Node to the DOM.
 *	@param {Element} dom			Element whose children should be compared & mutated
 *	@param {Array} vchildren		Array of VNodes to compare to `dom.childNodes`
 *	@param {Object} context			Implicitly descendant context object (from most recent `getChildContext()`)
 *	@param {Boolean} mountAll
 *	@param {Boolean} isHydrating	If `true`, consumes externally created elements similar to hydration
 */
function innerDiffNode(dom, vchildren, context, mountAll, isHydrating) {
	var originalChildren = dom.childNodes,
	    children = [],
	    keyed = {},
	    keyedLen = 0,
	    min = 0,
	    len = originalChildren.length,
	    childrenLen = 0,
	    vlen = vchildren ? vchildren.length : 0,
	    j,
	    c,
	    f,
	    vchild,
	    child;

	// Build up a map of keyed children and an Array of unkeyed children:
	if (len !== 0) {
		for (var i = 0; i < len; i++) {
			var _child = originalChildren[i],
			    props = _child['__preactattr_'],
			    key = vlen && props ? _child._component ? _child._component.__key : props.key : null;
			if (key != null) {
				keyedLen++;
				keyed[key] = _child;
			} else if (props || (_child.splitText !== undefined ? isHydrating ? _child.nodeValue.trim() : true : isHydrating)) {
				children[childrenLen++] = _child;
			}
		}
	}

	if (vlen !== 0) {
		for (var i = 0; i < vlen; i++) {
			vchild = vchildren[i];
			child = null;

			// attempt to find a node based on key matching
			var key = vchild.key;
			if (key != null) {
				if (keyedLen && keyed[key] !== undefined) {
					child = keyed[key];
					keyed[key] = undefined;
					keyedLen--;
				}
			}
			// attempt to pluck a node of the same type from the existing children
			else if (!child && min < childrenLen) {
					for (j = min; j < childrenLen; j++) {
						if (children[j] !== undefined && isSameNodeType(c = children[j], vchild, isHydrating)) {
							child = c;
							children[j] = undefined;
							if (j === childrenLen - 1) childrenLen--;
							if (j === min) min++;
							break;
						}
					}
				}

			// morph the matched/found/created DOM child to match vchild (deep)
			child = idiff(child, vchild, context, mountAll);

			f = originalChildren[i];
			if (child && child !== dom && child !== f) {
				if (f == null) {
					dom.appendChild(child);
				} else if (child === f.nextSibling) {
					removeNode(f);
				} else {
					dom.insertBefore(child, f);
				}
			}
		}
	}

	// remove unused keyed children:
	if (keyedLen) {
		for (var i in keyed) {
			if (keyed[i] !== undefined) recollectNodeTree(keyed[i], false);
		}
	}

	// remove orphaned unkeyed children:
	while (min <= childrenLen) {
		if ((child = children[childrenLen--]) !== undefined) recollectNodeTree(child, false);
	}
}

/** Recursively recycle (or just unmount) a node and its descendants.
 *	@param {Node} node						DOM node to start unmount/removal from
 *	@param {Boolean} [unmountOnly=false]	If `true`, only triggers unmount lifecycle, skips removal
 */
function recollectNodeTree(node, unmountOnly) {
	var component = node._component;
	if (component) {
		// if node is owned by a Component, unmount that component (ends up recursing back here)
		unmountComponent(component);
	} else {
		// If the node's VNode had a ref function, invoke it with null here.
		// (this is part of the React spec, and smart for unsetting references)
		if (node['__preactattr_'] != null && node['__preactattr_'].ref) node['__preactattr_'].ref(null);

		if (unmountOnly === false || node['__preactattr_'] == null) {
			removeNode(node);
		}

		removeChildren(node);
	}
}

/** Recollect/unmount all children.
 *	- we use .lastChild here because it causes less reflow than .firstChild
 *	- it's also cheaper than accessing the .childNodes Live NodeList
 */
function removeChildren(node) {
	node = node.lastChild;
	while (node) {
		var next = node.previousSibling;
		recollectNodeTree(node, true);
		node = next;
	}
}

/** Apply differences in attributes from a VNode to the given DOM Element.
 *	@param {Element} dom		Element with attributes to diff `attrs` against
 *	@param {Object} attrs		The desired end-state key-value attribute pairs
 *	@param {Object} old			Current/previous attributes (from previous VNode or element's prop cache)
 */
function diffAttributes(dom, attrs, old) {
	var name;

	// remove attributes no longer present on the vnode by setting them to undefined
	for (name in old) {
		if (!(attrs && attrs[name] != null) && old[name] != null) {
			setAccessor(dom, name, old[name], old[name] = undefined, isSvgMode);
		}
	}

	// add new & update changed attributes
	for (name in attrs) {
		if (name !== 'children' && name !== 'innerHTML' && (!(name in old) || attrs[name] !== (name === 'value' || name === 'checked' ? dom[name] : old[name]))) {
			setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
		}
	}
}

/** Retains a pool of Components for re-use, keyed on component name.
 *	Note: since component names are not unique or even necessarily available, these are primarily a form of sharding.
 *	@private
 */
var components = {};

/** Reclaim a component for later re-use by the recycler. */
function collectComponent(component) {
	var name = component.constructor.name;
	(components[name] || (components[name] = [])).push(component);
}

/** Create a component. Normalizes differences between PFC's and classful Components. */
function createComponent(Ctor, props, context) {
	var list = components[Ctor.name],
	    inst;

	if (Ctor.prototype && Ctor.prototype.render) {
		inst = new Ctor(props, context);
		Component.call(inst, props, context);
	} else {
		inst = new Component(props, context);
		inst.constructor = Ctor;
		inst.render = doRender;
	}

	if (list) {
		for (var i = list.length; i--;) {
			if (list[i].constructor === Ctor) {
				inst.nextBase = list[i].nextBase;
				list.splice(i, 1);
				break;
			}
		}
	}
	return inst;
}

/** The `.render()` method for a PFC backing instance. */
function doRender(props, state, context) {
	return this.constructor(props, context);
}

/** Set a component's `props` (generally derived from JSX attributes).
 *	@param {Object} props
 *	@param {Object} [opts]
 *	@param {boolean} [opts.renderSync=false]	If `true` and {@link options.syncComponentUpdates} is `true`, triggers synchronous rendering.
 *	@param {boolean} [opts.render=true]			If `false`, no render will be triggered.
 */
function setComponentProps(component, props, opts, context, mountAll) {
	if (component._disable) return;
	component._disable = true;

	if (component.__ref = props.ref) delete props.ref;
	if (component.__key = props.key) delete props.key;

	if (!component.base || mountAll) {
		if (component.componentWillMount) component.componentWillMount();
	} else if (component.componentWillReceiveProps) {
		component.componentWillReceiveProps(props, context);
	}

	if (context && context !== component.context) {
		if (!component.prevContext) component.prevContext = component.context;
		component.context = context;
	}

	if (!component.prevProps) component.prevProps = component.props;
	component.props = props;

	component._disable = false;

	if (opts !== 0) {
		if (opts === 1 || options.syncComponentUpdates !== false || !component.base) {
			renderComponent(component, 1, mountAll);
		} else {
			enqueueRender(component);
		}
	}

	if (component.__ref) component.__ref(component);
}

/** Render a Component, triggering necessary lifecycle events and taking High-Order Components into account.
 *	@param {Component} component
 *	@param {Object} [opts]
 *	@param {boolean} [opts.build=false]		If `true`, component will build and store a DOM node if not already associated with one.
 *	@private
 */
function renderComponent(component, opts, mountAll, isChild) {
	if (component._disable) return;

	var props = component.props,
	    state = component.state,
	    context = component.context,
	    previousProps = component.prevProps || props,
	    previousState = component.prevState || state,
	    previousContext = component.prevContext || context,
	    isUpdate = component.base,
	    nextBase = component.nextBase,
	    initialBase = isUpdate || nextBase,
	    initialChildComponent = component._component,
	    skip = false,
	    rendered,
	    inst,
	    cbase;

	// if updating
	if (isUpdate) {
		component.props = previousProps;
		component.state = previousState;
		component.context = previousContext;
		if (opts !== 2 && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === false) {
			skip = true;
		} else if (component.componentWillUpdate) {
			component.componentWillUpdate(props, state, context);
		}
		component.props = props;
		component.state = state;
		component.context = context;
	}

	component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
	component._dirty = false;

	if (!skip) {
		rendered = component.render(props, state, context);

		// context to pass to the child, can be updated via (grand-)parent component
		if (component.getChildContext) {
			context = extend(extend({}, context), component.getChildContext());
		}

		var childComponent = rendered && rendered.nodeName,
		    toUnmount,
		    base;

		if (typeof childComponent === 'function') {
			// set up high order component link

			var childProps = getNodeProps(rendered);
			inst = initialChildComponent;

			if (inst && inst.constructor === childComponent && childProps.key == inst.__key) {
				setComponentProps(inst, childProps, 1, context, false);
			} else {
				toUnmount = inst;

				component._component = inst = createComponent(childComponent, childProps, context);
				inst.nextBase = inst.nextBase || nextBase;
				inst._parentComponent = component;
				setComponentProps(inst, childProps, 0, context, false);
				renderComponent(inst, 1, mountAll, true);
			}

			base = inst.base;
		} else {
			cbase = initialBase;

			// destroy high order component link
			toUnmount = initialChildComponent;
			if (toUnmount) {
				cbase = component._component = null;
			}

			if (initialBase || opts === 1) {
				if (cbase) cbase._component = null;
				base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, true);
			}
		}

		if (initialBase && base !== initialBase && inst !== initialChildComponent) {
			var baseParent = initialBase.parentNode;
			if (baseParent && base !== baseParent) {
				baseParent.replaceChild(base, initialBase);

				if (!toUnmount) {
					initialBase._component = null;
					recollectNodeTree(initialBase, false);
				}
			}
		}

		if (toUnmount) {
			unmountComponent(toUnmount);
		}

		component.base = base;
		if (base && !isChild) {
			var componentRef = component,
			    t = component;
			while (t = t._parentComponent) {
				(componentRef = t).base = base;
			}
			base._component = componentRef;
			base._componentConstructor = componentRef.constructor;
		}
	}

	if (!isUpdate || mountAll) {
		mounts.unshift(component);
	} else if (!skip) {
		// Ensure that pending componentDidMount() hooks of child components
		// are called before the componentDidUpdate() hook in the parent.
		// Note: disabled as it causes duplicate hooks, see https://github.com/developit/preact/issues/750
		// flushMounts();

		if (component.componentDidUpdate) {
			component.componentDidUpdate(previousProps, previousState, previousContext);
		}
		if (options.afterUpdate) options.afterUpdate(component);
	}

	if (component._renderCallbacks != null) {
		while (component._renderCallbacks.length) {
			component._renderCallbacks.pop().call(component);
		}
	}

	if (!diffLevel && !isChild) flushMounts();
}

/** Apply the Component referenced by a VNode to the DOM.
 *	@param {Element} dom	The DOM node to mutate
 *	@param {VNode} vnode	A Component-referencing VNode
 *	@returns {Element} dom	The created/mutated element
 *	@private
 */
function buildComponentFromVNode(dom, vnode, context, mountAll) {
	var c = dom && dom._component,
	    originalComponent = c,
	    oldDom = dom,
	    isDirectOwner = c && dom._componentConstructor === vnode.nodeName,
	    isOwner = isDirectOwner,
	    props = getNodeProps(vnode);
	while (c && !isOwner && (c = c._parentComponent)) {
		isOwner = c.constructor === vnode.nodeName;
	}

	if (c && isOwner && (!mountAll || c._component)) {
		setComponentProps(c, props, 3, context, mountAll);
		dom = c.base;
	} else {
		if (originalComponent && !isDirectOwner) {
			unmountComponent(originalComponent);
			dom = oldDom = null;
		}

		c = createComponent(vnode.nodeName, props, context);
		if (dom && !c.nextBase) {
			c.nextBase = dom;
			// passing dom/oldDom as nextBase will recycle it if unused, so bypass recycling on L229:
			oldDom = null;
		}
		setComponentProps(c, props, 1, context, mountAll);
		dom = c.base;

		if (oldDom && dom !== oldDom) {
			oldDom._component = null;
			recollectNodeTree(oldDom, false);
		}
	}

	return dom;
}

/** Remove a component from the DOM and recycle it.
 *	@param {Component} component	The Component instance to unmount
 *	@private
 */
function unmountComponent(component) {
	if (options.beforeUnmount) options.beforeUnmount(component);

	var base = component.base;

	component._disable = true;

	if (component.componentWillUnmount) component.componentWillUnmount();

	component.base = null;

	// recursively tear down & recollect high-order component children:
	var inner = component._component;
	if (inner) {
		unmountComponent(inner);
	} else if (base) {
		if (base['__preactattr_'] && base['__preactattr_'].ref) base['__preactattr_'].ref(null);

		component.nextBase = base;

		removeNode(base);
		collectComponent(component);

		removeChildren(base);
	}

	if (component.__ref) component.__ref(null);
}

/** Base Component class.
 *	Provides `setState()` and `forceUpdate()`, which trigger rendering.
 *	@public
 *
 *	@example
 *	class MyFoo extends Component {
 *		render(props, state) {
 *			return <div />;
 *		}
 *	}
 */
function Component(props, context) {
	this._dirty = true;

	/** @public
  *	@type {object}
  */
	this.context = context;

	/** @public
  *	@type {object}
  */
	this.props = props;

	/** @public
  *	@type {object}
  */
	this.state = this.state || {};
}

extend(Component.prototype, {

	/** Returns a `boolean` indicating if the component should re-render when receiving the given `props` and `state`.
  *	@param {object} nextProps
  *	@param {object} nextState
  *	@param {object} nextContext
  *	@returns {Boolean} should the component re-render
  *	@name shouldComponentUpdate
  *	@function
  */

	/** Update component state by copying properties from `state` to `this.state`.
  *	@param {object} state		A hash of state properties to update with new values
  *	@param {function} callback	A function to be called once component state is updated
  */
	setState: function setState(state, callback) {
		var s = this.state;
		if (!this.prevState) this.prevState = extend({}, s);
		extend(s, typeof state === 'function' ? state(s, this.props) : state);
		if (callback) (this._renderCallbacks = this._renderCallbacks || []).push(callback);
		enqueueRender(this);
	},

	/** Immediately perform a synchronous re-render of the component.
  *	@param {function} callback		A function to be called after component is re-rendered.
  *	@private
  */
	forceUpdate: function forceUpdate(callback) {
		if (callback) (this._renderCallbacks = this._renderCallbacks || []).push(callback);
		renderComponent(this, 2);
	},

	/** Accepts `props` and `state`, and returns a new Virtual DOM tree to build.
  *	Virtual DOM is generally constructed via [JSX](http://jasonformat.com/wtf-is-jsx).
  *	@param {object} props		Props (eg: JSX attributes) received from parent element/component
  *	@param {object} state		The component's current state
  *	@param {object} context		Context object (if a parent component has provided context)
  *	@returns VNode
  */
	render: function render() {}
});

/** Render JSX into a `parent` Element.
 *	@param {VNode} vnode		A (JSX) VNode to render
 *	@param {Element} parent		DOM element to render into
 *	@param {Element} [merge]	Attempt to re-use an existing DOM tree rooted at `merge`
 *	@public
 *
 *	@example
 *	// render a div into <body>:
 *	render(<div id="hello">hello!</div>, document.body);
 *
 *	@example
 *	// render a "Thing" component into #foo:
 *	const Thing = ({ name }) => <span>{ name }</span>;
 *	render(<Thing name="one" />, document.querySelector('#foo'));
 */
function render(vnode, parent, merge) {
	return diff(merge, vnode, {}, false, parent, false);
}

var preact = {
	h: h,
	createElement: h,
	cloneElement: cloneElement,
	Component: Component,
	render: render,
	rerender: rerender,
	options: options
};

exports.h = h;
exports.createElement = h;
exports.cloneElement = cloneElement;
exports.Component = Component;
exports.render = render;
exports.rerender = rerender;
exports.options = options;
exports.default = preact;
//# sourceMappingURL=preact.esm.js.map

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toArray = exports.createUniqueId = exports.bem = undefined;

var _array = __webpack_require__(7);

var _bem = __webpack_require__(8);

var _bem2 = _interopRequireDefault(_bem);

var _string = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.bem = _bem2.default;
exports.createUniqueId = _string.createUniqueId;
exports.toArray = _array.toArray;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
  * domready (c) Dustin Diaz 2014 - License MIT
  */
!function (name, definition) {

  if (true) module.exports = definition();else if (typeof define == 'function' && _typeof(define.amd) == 'object') define(definition);else this[name] = definition();
}('domready', function () {

  var fns = [],
      _listener,
      doc = document,
      hack = doc.documentElement.doScroll,
      domContentLoaded = 'DOMContentLoaded',
      loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState);

  if (!loaded) doc.addEventListener(domContentLoaded, _listener = function listener() {
    doc.removeEventListener(domContentLoaded, _listener);
    loaded = 1;
    while (_listener = fns.shift()) {
      _listener();
    }
  });

  return function (fn) {
    loaded ? setTimeout(fn, 0) : fns.push(fn);
  };
});

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nodelistToArray = nodelistToArray;
function nodelistToArray(nodeList) {
  return [].slice.call(nodeList);
}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uuid = uuid;
function uuid() {
  return "_" + Math.random().toString(36).substr(2, 9);
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createErrorReporter = createErrorReporter;

var _dhSimpleErrorReport = __webpack_require__(6);

function createErrorReporter(isErrorReportingEnabled) {
  return new _dhSimpleErrorReport.SimpleErrorReport({
    name: 'dh-partibarometer',
    url: 'https://dh.nrk.no/catch',
    dryRun: !isErrorReportingEnabled
  });
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e, n) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? n(exports) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (n),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : n(e["simple-error-report"] = {});
}(undefined, function (e) {
  "use strict";
  var n = function () {
    function e(e, n) {
      for (var r = 0; r < n.length; r++) {
        var t = n[r];t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
      }
    }return function (n, r, t) {
      return r && e(n.prototype, r), t && e(n, t), n;
    };
  }();var r = function () {
    function e() {
      !function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.register = [];
    }return n(e, [{ key: "addErrorToRegister", value: function value(e) {
        this.register.push({ time: new Date(), message: e });
      } }, { key: "isInRegisterWithinRange", value: function value(e, n) {
        return this.register.filter(function (r) {
          return r.message === e && new Date() - r.time < n;
        }).length > 0;
      } }]), e;
  }(),
      t = function () {
    function e(e, n) {
      for (var r = 0; r < n.length; r++) {
        var t = n[r];t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
      }
    }return function (n, r, t) {
      return r && e(n.prototype, r), t && e(n, t), n;
    };
  }();var i = [],
      o = function () {
    function e(n) {
      var t = n.name,
          o = n.url,
          s = n.dryRun,
          a = void 0 === s || s;!function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.name = t, this.url = o, this.errorRegister = new r(), this.dryRun = a, i.push(this.name);
    }return t(e, [{ key: "listenAndCatch", value: function value() {
        var e = this;i.length <= 1 && (window.addEventListener("error", function (n) {
          var r = n.message,
              t = n.filename,
              i = n.lineno,
              o = n.colno,
              s = { message: r };"" !== t && (s.url = t), i > 0 && (s.line = i), o > 0 && (s.column = o), e.sendErrorReport(s);
        }), window.addEventListener("unhandledrejection", function (n) {
          e.sendErrorReport({ message: "Unhandled Promise Rejection: " + n.reason });
        }));
      } }, { key: "sendErrorReport", value: function value(e) {
        var n, r, t;this.dryRun ? "undefined" != typeof console && console.log("Dry run: " + JSON.stringify(e)) : this.errorRegister.isInRegisterWithinRange(e.message, 500) || (this.errorRegister.addErrorToRegister(e.message), n = this.url + "/" + this.name, r = e, (t = new XMLHttpRequest()).open("POST", n), t.setRequestHeader("Content-Type", "application/json"), t.send(JSON.stringify(r)));
      } }]), e;
  }();e.SimpleErrorReport = o, Object.defineProperty(e, "__esModule", { value: !0 });
});

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toArray = toArray;
function toArray(nodeList) {
  return [].slice.call(nodeList);
}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

function toStrings(object) {
  return Object.keys(object).filter(function (key) {
    return object[key];
  });
}

exports.default = function (blockName) {
  for (var _len = arguments.length, modifiers = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    modifiers[_key - 1] = arguments[_key];
  }

  var strings = modifiers.filter(function (modifier) {
    return typeof modifier === 'string';
  });
  var objects = modifiers.filter(function (modifier) {
    return (typeof modifier === 'undefined' ? 'undefined' : _typeof(modifier)) === 'object';
  });

  var objectString = objects.map(function (object) {
    return toStrings(object);
  }).reduce(function (a, b) {
    return [].concat(_toConsumableArray(a), _toConsumableArray(b));
  }, []);

  return [blockName].concat(strings.map(function (modifier) {
    return blockName + '--' + modifier;
  })).concat(objectString.map(function (modifier) {
    return blockName + '--' + modifier;
  })).join(' ');
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUniqueId = createUniqueId;
function createUniqueId() {
  var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return '' + prefix + Math.random().toString(36).substr(2, len - prefix.length);
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e, n) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? n(exports) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (n),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : n(e["dh-analytics-utils"] = {});
}(undefined, function (e) {
  "use strict";
  function n() {
    return window.ga;
  }var t = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];for (var o in t) {
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
      }
    }return e;
  };e.createGoogleAnalyticsTracker = function (e) {
    var o = [],
        r = e.name,
        a = e.gaPropertyId,
        i = e.self,
        l = e.context;if (!(r && a && i && l)) throw new Error("Unable to create google analytics tracker. Please pass an object containing name, gaPropertyId, self and context to createGoogleAnalyticsTracker method");var c,
        s,
        d,
        u,
        f,
        g,
        p,
        y,
        w = (c = i.id, s = l.id, d = i.title, u = i.publishedDate, f = c === s, g = document.referrer, { dimension1: c ? "pp:" + c : null, dimension2: d || null, dimension3: u ? String(u.getFullYear()) : null, dimension4: u ? String(u.getMonth() + 1) : null, dimension5: u ? String(u.getDate()) : null, dimension6: g.replace(/^(https?:\/\/)?www./, "$1"), dimension7: g.replace(/^(https?:\/\/)/, "").replace(/^www./, ""), dimension10: f ? null : s ? "pp:" + s : null }),
        v = (p = o, y = !1, function (e, o, r, a, i) {
      if (!r.category || !r.action) throw new Error("Error sending event to google analytics: Event is missing mandatory fields category and/or action");n() ? (y || (function (e, n) {
        window.ga("create", { trackingId: n, cookieDomain: "auto", name: e }), window.ga(e + ".set", "anonymizeIp", !0);
      }(e, o), y = !0), window.ga(e + ".send", "event", function (e, n) {
        var o = {};e.hasOwnProperty("category") && (o.eventCategory = e.category), e.hasOwnProperty("action") && (o.eventAction = e.action), e.hasOwnProperty("label") && (o.eventLabel = e.label), e.hasOwnProperty("value") && (o.eventValue = e.value), o.nonInteraction = e.nonInteraction || !1;var r = t({}, n, e.fieldsObject);return t({}, o, r);
      }(r, a))) : p.push(r);
    }),
        m = setInterval(function () {
      if (n()) for (clearInterval(m); o.length;) {
        var e = o.shift();v(r, a, e, w);
      }
    }, 1e3);return { sendEvent: function sendEvent(e) {
        v(r, a, e, w);
      } };
  }, Object.defineProperty(e, "__esModule", { value: !0 });
});

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContextId = getContextId;
var POLOPOLY_ID_REGEX = /[1-9]{1,2}\.\d+/g;

function getContextId(url) {
  return extractPolopolyIdFromString(url);
}

function extractPolopolyIdFromString(str) {
  var matches = str.match(POLOPOLY_ID_REGEX);
  if (matches && matches.length) {
    return matches[0];
  }
  return null;
}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prettyPrintNumber = prettyPrintNumber;
function prettyPrintNumber(num) {
  return String(num).replace('.', ',');
}

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"withComparisonRoot":"dh-partibarometer-withComparisonRoot","withComparison":"dh-partibarometer-withComparison","fadeIn":"dh-partibarometer-fadeIn","withComparison__header":"dh-partibarometer-withComparison__header","withComparison__title":"dh-partibarometer-withComparison__title","withComparison__description":"dh-partibarometer-withComparison__description","withComparison__columnHeaders":"dh-partibarometer-withComparison__columnHeaders","withComparison__columnHeaders--medium":"dh-partibarometer-withComparison__columnHeaders--medium","withComparison__columnHeaders--wide":"dh-partibarometer-withComparison__columnHeaders--wide","withComparison__partyColumns":"dh-partibarometer-withComparison__partyColumns","withComparison__partyColumns--narrow":"dh-partibarometer-withComparison__partyColumns--narrow","withComparison__partyColumns--medium":"dh-partibarometer-withComparison__partyColumns--medium","withComparison__partyColumns--wide":"dh-partibarometer-withComparison__partyColumns--wide","withComparison__source":"dh-partibarometer-withComparison__source"};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidthAsText = getWidthAsText;
var _narrow = 'narrow';
var _medium = 'medium';
var _wide = 'wide';

function getWidthAsText(width) {
  if (!width) {
    return _narrow;
  }
  if (width < 540) {
    return _narrow;
  } else if (width < 720) {
    return _medium;
  } else {
    return _wide;
  }
}

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(21);
module.exports = __webpack_require__(22);


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable */


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _domready = __webpack_require__(2);

var _domready2 = _interopRequireDefault(_domready);

var _preact = __webpack_require__(0);

var _nodelistToArray = __webpack_require__(3);

var _uuid = __webpack_require__(4);

var _errorReporting = __webpack_require__(5);

var _App = __webpack_require__(23);

var _App2 = __webpack_require__(14);

var _dhAnalyticsUtils = __webpack_require__(10);

var _getContextId = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window[_App2.withComparisonRoot] = window[_App2.withComparisonRoot] || {}; /* global __HOT__ */
// @jsx h


function init() {
  findElements().forEach(function (el) {
    el.id = (0, _uuid.uuid)();
    window[_App2.withComparisonRoot][el.id] = true;

    // Extract preloaded state sent from server
    var preloadedState = JSON.parse(el.getAttribute('data-preloaded-state'));
    var errorEventTrackingEnabled = JSON.parse(el.getAttribute('data-error-event-tracking-enabled'));

    // Register error reporter
    var simpleErrorReport = (0, _errorReporting.createErrorReporter)(errorEventTrackingEnabled);
    simpleErrorReport.listenAndCatch();

    // Extract metadata required to create google analytics tracker
    var gaPropertyId = el.getAttribute('data-ga-property-id');
    var metadata = JSON.parse(el.getAttribute('data-metadata'));
    var title = metadata.title,
        selfId = metadata.selfId,
        published = metadata.published;

    // create google analytics tracker

    var googleAnalyticsTracker = (0, _dhAnalyticsUtils.createGoogleAnalyticsTracker)({
      name: 'dh',
      gaPropertyId: gaPropertyId,
      self: {
        id: selfId,
        title: title,
        publishedDate: published ? new Date(published) : null
      },
      context: {
        id: (0, _getContextId.getContextId)(document.location.href)
      }
    });

    // ... and render with the exact same props
    (0, _preact.render)((0, _preact.h)(_App.App, preloadedState), el, el.firstChild);

    // track load event
    googleAnalyticsTracker.sendEvent({
      category: 'dh-modul\u2013partibarometer',
      label: 'sammenlikning',
      action: 'load',
      value: new Date().getTime()
    });

    // Enable webpack hot-reloading
    if (false) {
      // Reload and re-render React application
      module.hot.accept('./withComparison-client', function () {
        (0, _preact.render)(require('./components/withComparison/App').default, el);
      });
    }
  });
}

function findElements() {
  return (0, _nodelistToArray.nodelistToArray)(document.getElementsByClassName(_App2.withComparisonRoot)).filter(function (el) {
    return !isInitialized(el);
  });
}

function isInitialized(el) {
  return el.id && window[_App2.withComparisonRoot][el.id];
}

(0, _domready2.default)(init);

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

var _App = __webpack_require__(14);

var _App2 = _interopRequireDefault(_App);

var _PartyColumn = __webpack_require__(24);

var _dhUtils = __webpack_require__(1);

var _getWidthAsText = __webpack_require__(15);

var _prettyPrintNumber = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //  @jsx h


var App = exports.App = function (_Component) {
  _inherits(App, _Component);

  function App() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = App.__proto__ || Object.getPrototypeOf(App)).call.apply(_ref, [this].concat(args))), _this), _this.resizeHandler = function () {
      _this.setState({
        containerWidth: _this.element.offsetWidth
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ containerWidth: this.element.offsetWidth });
      window.addEventListener('resize', this.resizeHandler);
      window.addEventListener('orientationchange', this.resizeHandler);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.resizeHandler);
      window.removeEventListener('orientationchange', this.resizeHandler);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          title = _props.title,
          surveyMetadata = _props.surveyMetadata,
          politicalParties = _props.politicalParties;
      var containerWidth = this.state.containerWidth;

      var previousValues = politicalParties.map(function (party) {
        return party.previousPeriod;
      });
      var currentValues = politicalParties.map(function (party) {
        return party.currentPeriod;
      });
      var maxValue = Math.max.apply(Math, _toConsumableArray(previousValues.concat(currentValues)));
      var widthAsText = (0, _getWidthAsText.getWidthAsText)(containerWidth);

      return (0, _preact.h)(
        'div',
        { ref: function ref(el) {
            _this2.element = el;
          }, className: _App2.default.withComparison },
        (0, _preact.h)(
          'header',
          { className: _App2.default.withComparison__header },
          (0, _preact.h)(
            'h1',
            { className: _App2.default.withComparison__title },
            title
          ),
          (0, _preact.h)(
            'div',
            { className: _App2.default.withComparison__description },
            createDescription(surveyMetadata)
          )
        ),
        (0, _preact.h)(
          'div',
          { className: (0, _dhUtils.bem)(_App2.default.withComparison__columnHeaders, widthAsText), 'aria-hidden': 'true' },
          (0, _preact.h)(
            'div',
            { className: _App2.default.withComparison__header__party },
            'Parti'
          ),
          (0, _preact.h)(
            'div',
            { className: _App2.default.withComparison__header__diff },
            'Endring'
          )
        ),
        (0, _preact.h)(
          'div',
          { className: (0, _dhUtils.bem)(_App2.default.withComparison__partyColumns, widthAsText) },
          politicalParties.map(function (party) {
            return (0, _preact.h)(_PartyColumn.PartyColumn, {
              key: party.nameShort,
              containerWidth: containerWidth,
              politicalParty: party,
              maxValue: maxValue });
          })
        ),
        (0, _preact.h)(
          'div',
          { className: _App2.default.withComparison__source },
          'Kilde: ',
          surveyMetadata.source
        )
      );
    }
  }]);

  return App;
}(_preact.Component);

function createDescription(surveyMetadata) {
  var startDate = surveyMetadata.startDate,
      endDate = surveyMetadata.endDate,
      interviewCount = surveyMetadata.interviewCount,
      errorMarginLowest = surveyMetadata.errorMarginLowest,
      errorMarginLargest = surveyMetadata.errorMarginLargest;

  return 'Periode ' + startDate + '\u2013' + endDate + '. ' + interviewCount + ' intervjuer. Feilmarginer fra ' + (0, _prettyPrintNumber.prettyPrintNumber)(errorMarginLowest) + '\u2013' + (0, _prettyPrintNumber.prettyPrintNumber)(errorMarginLargest) + ' pp.';
}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PartyColumn = PartyColumn;

var _preact = __webpack_require__(0);

var _dhUtils = __webpack_require__(1);

var _PartyColumn = __webpack_require__(25);

var _PartyColumn2 = _interopRequireDefault(_PartyColumn);

var _getWidthAsText = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  @jsx h
function formatPercentage(value) {
  return value.toFixed(1).replace('.', ',');
}

function formatChange(value) {
  var str = value.toFixed(1).replace('.', ',');
  return value < 0 ? '\u2212' + str.substr(1) : '+' + str;
}

function getSummary(politicalParty) {
  var name = politicalParty.name,
      previousPeriod = politicalParty.previousPeriod,
      currentPeriod = politicalParty.currentPeriod;

  var diff = currentPeriod - previousPeriod;

  var text = void 0;
  if (diff === 0) {
    text = 'det samme som ved forrige måling';
  } else {
    text = formatPercentage(Math.abs(diff)) + ' prosentpoeng ' + (diff > 0 ? 'mer' : 'mindre') + ' enn ved forrige m\xE5ling';
  }
  return name + ' har ' + currentPeriod + ' % oppslutning \u2013 ' + text;
}

function PartyColumn(props) {
  var politicalParty = props.politicalParty,
      maxValue = props.maxValue,
      containerWidth = props.containerWidth;
  var nameShort = politicalParty.nameShort,
      previousPeriod = politicalParty.previousPeriod,
      currentPeriod = politicalParty.currentPeriod;

  var diff = currentPeriod - previousPeriod;
  var previousPeriodSizePercent = previousPeriod / maxValue * 100;
  var currentPeriodSizePercent = currentPeriod / maxValue * 100;
  var widthAsText = (0, _getWidthAsText.getWidthAsText)(containerWidth);

  return (0, _preact.h)(
    'div',
    { className: (0, _dhUtils.bem)(_PartyColumn2.default.withComparisonPartyColumn, widthAsText), 'aria-label': getSummary(politicalParty) },
    (0, _preact.h)(
      'div',
      { className: (0, _dhUtils.bem)(_PartyColumn2.default.withComparisonPartyColumn__barContainer, widthAsText), 'aria-hidden': 'true' },
      (0, _preact.h)('div', { className: (0, _dhUtils.bem)(_PartyColumn2.default.withComparisonPartyColumn__bar, nameShort, 'previous', widthAsText), style: {
          width: previousPeriodSizePercent + '%',
          height: previousPeriodSizePercent + '%'
        } }),
      (0, _preact.h)(
        'div',
        { className: (0, _dhUtils.bem)(_PartyColumn2.default.withComparisonPartyColumn__bar, nameShort, widthAsText), style: {
            width: currentPeriodSizePercent + '%',
            height: currentPeriodSizePercent + '%'
          } },
        (0, _preact.h)(
          'div',
          { className: (0, _dhUtils.bem)(_PartyColumn2.default.withComparisonPartyColumn__bar__diff, widthAsText), 'aria-hidden': 'true' },
          formatChange(diff)
        )
      )
    ),
    (0, _preact.h)(
      'div',
      { className: (0, _dhUtils.bem)(_PartyColumn2.default.withComparisonPartyColumn__name, widthAsText) },
      nameShort
    ),
    (0, _preact.h)(
      'div',
      { className: (0, _dhUtils.bem)(_PartyColumn2.default.withComparisonPartyColumn__value, widthAsText) },
      formatPercentage(currentPeriod),
      ' %'
    ),
    (0, _preact.h)(
      'div',
      { className: (0, _dhUtils.bem)(_PartyColumn2.default.withComparisonPartyColumn__diff, widthAsText) },
      formatChange(diff)
    )
  );
}

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"withComparisonPartyColumn":"dh-partibarometer-withComparisonPartyColumn","withComparisonPartyColumn--narrow":"dh-partibarometer-withComparisonPartyColumn--narrow","withComparisonPartyColumn--medium":"dh-partibarometer-withComparisonPartyColumn--medium","withComparisonPartyColumn--wide":"dh-partibarometer-withComparisonPartyColumn--wide","withComparisonPartyColumn__barContainer":"dh-partibarometer-withComparisonPartyColumn__barContainer","withComparisonPartyColumn__barContainer--narrow":"dh-partibarometer-withComparisonPartyColumn__barContainer--narrow","withComparisonPartyColumn__barContainer--medium":"dh-partibarometer-withComparisonPartyColumn__barContainer--medium","withComparisonPartyColumn__barContainer--wide":"dh-partibarometer-withComparisonPartyColumn__barContainer--wide","withComparisonPartyColumn__bar":"dh-partibarometer-withComparisonPartyColumn__bar","withComparisonPartyColumn__bar--narrow":"dh-partibarometer-withComparisonPartyColumn__bar--narrow","withComparisonPartyColumn__bar--medium":"dh-partibarometer-withComparisonPartyColumn__bar--medium","withComparisonPartyColumn__bar--wide":"dh-partibarometer-withComparisonPartyColumn__bar--wide","withComparisonPartyColumn__bar__diff":"dh-partibarometer-withComparisonPartyColumn__bar__diff","withComparisonPartyColumn__bar__diff--medium":"dh-partibarometer-withComparisonPartyColumn__bar__diff--medium","withComparisonPartyColumn__bar__diff--wide":"dh-partibarometer-withComparisonPartyColumn__bar__diff--wide","withComparisonPartyColumn__bar--previous":"dh-partibarometer-withComparisonPartyColumn__bar--previous","withComparisonPartyColumn__bar--R":"dh-partibarometer-withComparisonPartyColumn__bar--R","withComparisonPartyColumn__bar--SV":"dh-partibarometer-withComparisonPartyColumn__bar--SV","withComparisonPartyColumn__bar--AP":"dh-partibarometer-withComparisonPartyColumn__bar--AP","withComparisonPartyColumn__bar--SP":"dh-partibarometer-withComparisonPartyColumn__bar--SP","withComparisonPartyColumn__bar--MDG":"dh-partibarometer-withComparisonPartyColumn__bar--MDG","withComparisonPartyColumn__bar--KRF":"dh-partibarometer-withComparisonPartyColumn__bar--KRF","withComparisonPartyColumn__bar--V":"dh-partibarometer-withComparisonPartyColumn__bar--V","withComparisonPartyColumn__bar--H":"dh-partibarometer-withComparisonPartyColumn__bar--H","withComparisonPartyColumn__bar--FRP":"dh-partibarometer-withComparisonPartyColumn__bar--FRP","withComparisonPartyColumn__bar--Andre":"dh-partibarometer-withComparisonPartyColumn__bar--Andre","withComparisonPartyColumn__inlineValue":"dh-partibarometer-withComparisonPartyColumn__inlineValue","withComparisonPartyColumn__inlineValue--narrow":"dh-partibarometer-withComparisonPartyColumn__inlineValue--narrow","withComparisonPartyColumn__inlineValue--medium":"dh-partibarometer-withComparisonPartyColumn__inlineValue--medium","withComparisonPartyColumn__inlineValue--wide":"dh-partibarometer-withComparisonPartyColumn__inlineValue--wide","withComparisonPartyColumn__name":"dh-partibarometer-withComparisonPartyColumn__name","withComparisonPartyColumn__name--narrow":"dh-partibarometer-withComparisonPartyColumn__name--narrow","withComparisonPartyColumn__name--medium":"dh-partibarometer-withComparisonPartyColumn__name--medium","withComparisonPartyColumn__name--wide":"dh-partibarometer-withComparisonPartyColumn__name--wide","withComparisonPartyColumn__value":"dh-partibarometer-withComparisonPartyColumn__value","withComparisonPartyColumn__value--narrow":"dh-partibarometer-withComparisonPartyColumn__value--narrow","withComparisonPartyColumn__value--wide":"dh-partibarometer-withComparisonPartyColumn__value--wide","withComparisonPartyColumn__diff":"dh-partibarometer-withComparisonPartyColumn__diff","withComparisonPartyColumn__diff--narrow":"dh-partibarometer-withComparisonPartyColumn__diff--narrow","withComparisonPartyColumn__diff--medium":"dh-partibarometer-withComparisonPartyColumn__diff--medium","withComparisonPartyColumn__diff--wide":"dh-partibarometer-withComparisonPartyColumn__diff--wide"};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// v1-withComparison-bundle-9eb474fadc67f48eb838.js